import Vue from 'vue'

import {Room} from "@/core/api/room.api"
import {} from "@/core/api/room.user.api"
import {} from "@/core/api/room.waiting.api";

import {Device} from "@/utils";

export default{
    install(Vue){
        Vue.prototype.$roomApi = Room
        Object.assign(Vue.prototype, {
            getDocument: function(){
                return this.$el?.ownerDocument || document;
            },
            getBody: function() {
                return this.getDocument().body;
            },
            getDefaultView: function(){
                return this.getDocument()?.defaultView || window;
            }
        });

        Object.assign(Vue.prototype, {
            getFileChooser: function(attrs){
                return new Promise((resolve, reject) => {
                    let inp = this.getDocument().createElement('input');
                    const inpAttrs = Object.assign({}, attrs, {
                        type: 'file'
                    });
                    Object.assign(inp, inpAttrs);
                    inp.addEventListener('click', e => {
                        e.stopPropagation();
                    });
                    inp.addEventListener('cancel', e => {
                        reject('cancel');
                        inp.remove();
                    });
                    inp.addEventListener('change', e => {
                        resolve(e.target.files);
                        inp.remove();
                    });
                    inp.click();

                    if(Device.isMobile() || Device.isTablet()){
                        const listener = e => {
                            if(e.target.hidden) return;
                            e.target.removeEventListener('visibilitychange', listener);
                            inp.remove();
                        }
                        this.getDocument().addEventListener('visibilitychange', listener);
                    }
                });
            },

            compressImage: function(file, maxSizeBytes, maxDimension = 268) {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = (event) => {
                        const img = new Image();
                        img.src = event.target.result;
                        img.onload = () => {
                            let width = img.width;
                            let height = img.height;

                            // 최대 치수 적용 (기본값 268px)
                            if (width > maxDimension || height > maxDimension) {
                                const aspectRatio = width / height;
                                if (width > height) {
                                    width = maxDimension;
                                    height = Math.round(maxDimension / aspectRatio);
                                } else {
                                    height = maxDimension;
                                    width = Math.round(maxDimension * aspectRatio);
                                }
                            }

                            const imageCanvas = document.createElement('canvas');
                            const ctx = imageCanvas.getContext('2d');

                            let quality = 0.7;
                            let resultBlob = null;

                            const compress = (q) => {
                                imageCanvas.width = width;
                                imageCanvas.height = height;
                                ctx.drawImage(img, 0, 0, width, height);

                                imageCanvas.toBlob((blob) => {
                                    resultBlob = blob;
                                    if (blob.size > maxSizeBytes && q > 0.1) {
                                        if (q > 0.3) {
                                            quality = q - 0.1;
                                            compress(quality);
                                        } else {
                                            width = Math.round(width * 0.9);
                                            height = Math.round(height * 0.9);
                                            compress(q);
                                        }
                                    } else {
                                        const compressedFile = new File([resultBlob], file.name, {
                                            type: file.type,
                                            lastModified: Date.now()
                                        });

                                        img.onload = null;
                                        img.src = '';
                                        imageCanvas.width = 0;
                                        imageCanvas.height = 0;

                                        resolve(compressedFile);
                                    }
                                }, file.type, q);
                            };
                            compress(quality);
                        };
                    };
                });
            }
        });

        Object.assign(Vue.prototype, {
            $Device: Device,
            $isBrowserAvailable: function(){
                return Device.isBrowserAvailable.apply(Device, arguments);
            },
        })



    }
}
